// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"4cdd34c8","184":"9b41c5d8","229":"c6a4487a","422":"1d816f40","571":"6965a827","670":"6b552beb","750":"ff5993fa","824":"0fd5b752"}[chunkId] + ".chunk.js";
};